import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import logo from 'assets/images/logo-gc.png'

import Success from './Success'

const Form = (props) => {
  if (props.auth.isRegistered) {
    return (
      <Success />
    )
  }
  return (
    <form
      name="signup-form"
      className="signup-form"
      onSubmit={props.handleSignup(props.signupData, props.auth.isPasswordMatch)}
    >
      <div className="logo">
        <Link to="/">
          <img src={logo} style={{ width: '200px' }} alt="logo" />
        </Link>
      </div>
      <h3 className="form-title font-green">Admin panel <br /><small>Registration</small></h3>
      <div className="form-group">
        <label htmlFor="email" className="control-label visible-ie8 visible-ie9">Email</label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="email"
          id="email"
          name="email"
          placeholder="Email address"
          required
          value={props.signupData.email}
          onChange={props.handleInputChange(props.signupData)}
        />
      </div>
      <div className="form-group">
        <label
          htmlFor="firstName"
          className="control-label visible-ie8 visible-ie9"
        >
          First Name
        </label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="text"
          id="firstName"
          name="firstName"
          placeholder="First Name"
          required
          value={props.signupData.firstName}
          onChange={props.handleInputChange(props.signupData)}
        />
      </div>
      <div className="form-group">
        <label
          htmlFor="lastName"
          className="control-label visible-ie8 visible-ie9"
        >
          Last Name
        </label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="text"
          id="lastName"
          name="lastName"
          placeholder="Last Name"
          required
          value={props.signupData.lastName}
          onChange={props.handleInputChange(props.signupData)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="password" className="control-label visible-ie8 visible-ie9">
          Password
        </label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          required
          pattern=".{8,}"
          title="8 characters minimum"
          value={props.signupData.password}
          onChange={props.handleInputChange(props.signupData)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="password" className="control-label visible-ie8 visible-ie9">
          Re-type Password
        </label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="password"
          id="retypePassword"
          name="retypePassword"
          placeholder="Re-type Password"
          required
          pattern=".{8,}"
          title="8 characters minimum"
          value={props.signupData.retypePassword}
          onChange={props.handleInputChange(props.signupData)}
        />
      </div>
      {!props.auth.isPasswordMatch && props.auth.isTypingPassword && (
        <div className="form-group">
          <div className="alert alert-danger">
            <strong>Whoops!</strong> Password does not match
          </div>
        </div>
      )}
      {props.auth.isError && (
        <div className="form-group">
          <div className="alert alert-danger">
            <strong>Whoops!</strong> {props.auth.errorMessage}
          </div>
        </div>
      )}
      <div className="form-group">
        <button type="submit" className="btn green uppercase">Register</button>
      </div>
      <div>
        <Link to="/" className="font-dark" style={{ textDecoration: 'underline' }}>
          <small>Already have an account? Sign in here</small>
        </Link>
      </div>
    </form>
  )
}

Form.propTypes = {
  auth: PropTypes.shape({
    isError: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    isRegistered: PropTypes.bool.isRequired,
    isPasswordMatch: PropTypes.bool.isRequired,
    isTypingPassword: PropTypes.bool.isRequired,
  }).isRequired,
  signupData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    retypePassword: PropTypes.string.isRequired,
  }).isRequired,
  handleSignup: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
}

export default Form
